import {
  configApiRef,
  createApiFactory,
  createComponentExtension,
  createPlugin,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { patternRef } from './api/pattern-api';
import { PatternClient } from './api/pattern-client';

export const patternsFrontendPlugin = createPlugin({
  id: 'patterns-frontend',
  apis: [
    createApiFactory({
      api: patternRef,
      deps: { configApi: configApiRef, identityApi: identityApiRef },
      factory: ({ configApi, identityApi }) =>
        new PatternClient({ configApi, identityApi }),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const PatternsFrontendPage = patternsFrontendPlugin.provide(
  createComponentExtension({
    name: 'PatternsFrontendPage',
    component: {
      lazy: () =>
        import('./components/pattern/PatternAdoptionContent').then(
          m => m.PatternContent,
        ),
    },
  }),
);
